import { render, staticRenderFns } from "./SensibleTrunkAnalysis2.vue?vue&type=template&id=ede78400&scoped=true"
import script from "./SensibleTrunkAnalysis2.vue?vue&type=script&lang=ts"
export * from "./SensibleTrunkAnalysis2.vue?vue&type=script&lang=ts"
import style0 from "./SensibleTrunkAnalysis2.vue?vue&type=style&index=0&id=ede78400&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede78400",
  null
  
)

export default component.exports